import React from "react";
import { useTranslation } from "react-i18next";
import BrandNav from "../../components/BrandNav";

export default function RoboticsGirlsAtTec() {
  const { t } = useTranslation();
  return (
    <>
      <BrandNav />
      <main className="ftg-page">
        <h1>{t("robotics.girls_title")}</h1>
        <p>{t("robotics.girls_subtitle")}</p>
      </main>
    </>
  );
}
